import { render, staticRenderFns } from "./homeProductList.vue?vue&type=template&id=52ce58a8"
import script from "./homeProductList.vue?vue&type=script&lang=js"
export * from "./homeProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports